import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { fetchOrderSubsListRequest } from '@/lib/service';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';

export default function useFollowExportPremium() {
  const { isLogin } = useUserProvider();
  const [plan, setPlan] = useState(null);
  const router = useRouter();

  useEffect(() => {
    if (!isLogin) {
      setPlan(null);
    } else {
      fetchOrderSubsListRequest('follow_export', router.locale).then((res: any) => {
        setPlan(res.data?.length > 0 ? res.data[res.data.length - 1] : null);
      });
    }
  }, [isLogin]);
  const isValid = plan?.expire_time && dayjs().isBefore(dayjs(plan?.expire_time));
  return {
    isPremium: !!(isLogin && isValid),
  };
}
